<form #columnsForm="ngForm">
  <p-dialog modal="true" styleClass="atlas-dialog-v" [closable]="false" [draggable]="false" [(visible)]="show">
    <ng-template #header>
      <h4>
        {{ 'profiles.search.manage-columns.title' | translate | titlecase }}
      </h4>
    </ng-template>
    <div cdkDropList (cdkDropListDropped)="sorted($event)" class="field-card-container" *ngIf="settings">
      <div cdkDrag class="field-card" *ngFor="let column of settings.SelectedFields; let i = index">
        <div>
          <div class="icon grip wc-movable"></div>
          <div *ngIf="selectedFieldMap && column.StandardFieldId == fieldEnum.ProfileName">
            {{ selectedFieldMap[column.StandardFieldId].label }}
          </div>
          <div
            *ngIf="column.FieldTypeEnum == selectorTypeEnum.StandardField && column.StandardFieldId != fieldEnum.ProfileName">
            <p-select [name]="'fieldName' + i" placeholder="{{ 'common.select' | translate }}"
              [options]="availableFields" [(ngModel)]="column.StandardFieldId" [style]="{ width: '400px' }"
              [placeholder]="'common.select' | translate | ucfirst" appendTo="body" required></p-select>
          </div>
          <div *ngIf="column.FieldTypeEnum == selectorTypeEnum.CustomField">
            <p-select [name]="'customFieldName' + i" placeholder="{{ 'common.select' | translate }}"
              [options]="customFields" [(ngModel)]="column.CustomFieldId" [style]="{ width: '400px' }"
              [placeholder]="'common.select' | translate | ucfirst" appendTo="body" required></p-select>
          </div>
          <div *ngIf="column.FieldTypeEnum == selectorTypeEnum.AffCodeType">
            <p-select [name]="'affCodeTypeName' + i" placeholder="{{ 'common.select' | translate }}"
              [options]="affCodeTypes" [(ngModel)]="column.AffCodeTypeId" [style]="{ width: '400px' }"
              [placeholder]="'common.select' | translate | ucfirst" appendTo="body" required></p-select>
          </div>
          <div *ngIf="column.FieldTypeEnum == selectorTypeEnum.AffCode">
            <p-select [name]="'affCodeName' + i" placeholder="{{ 'common.select' | translate }}" [options]="affCodes"
              [(ngModel)]="column.AffiliationId" [style]="{ width: '400px' }"
              [placeholder]="'common.select' | translate | ucfirst" appendTo="body" required></p-select>
          </div>
          <div *ngIf="column.StandardFieldId == fieldEnum.ProfileName" class="icon lock"></div>
          <button type="button" *ngIf="column.StandardFieldId != fieldEnum.ProfileName" class="atlas-btn atlas-btn-secondary pi pi-times-circle tall"
            (click)="removeColumn(i)"></button>
        </div>
      </div>
    </div>
    <ng-template #footer>
      <div class="footer-panel">
        <div class="footer-buttons footer-buttons-row">
          <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="addSystemField()">
            {{ 'profiles.search.manage-columns.add-system-field' | translate | titlecase }}
          </button>
          <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="addCustomField()">
            {{ 'profiles.search.manage-columns.add-custom-field' | translate | titlecase }}
          </button>
          <action-button styleClass="atlas-btn atlas-btn-default"
            [label]="'profiles.search.manage-columns.add-affiliation-field' | translate | titlecase"
            [items]="rowMenuItems">
          </action-button>
        </div>
        <div class="footer-buttons footer-buttons-row">
          <div>
            <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="clearColumns()">
              {{ 'profiles.search.manage-columns.clear-columns' | translate | uppercase }}
            </button>
          </div>
          <div class="footer-buttons footer-buttons-group">
            <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="show = false">
              {{ 'common.cancel' | translate | uppercase }}
            </button>
            <button pButton class="atlas-btn atlas-btn-primary"
              [title]="columnsForm.invalid ? ('profiles.search.manage-columns.select-all-field-values' | translate) : ''"
              [disabled]="!!!settings?.SelectedFields?.length || columnsForm.invalid" (click)="save()">
              {{ 'common.save' | translate | uppercase }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-dialog>
</form>
